import { useNavigate } from 'react-router-dom';
import { useSupabaseAuth } from '../context/AuthContext';

export default function UserLanding() {
  const navigate = useNavigate();
  const { signOut, profile } = useSupabaseAuth();

  return (
    <div className="content">
      <div className="prog-hero">
        <div className="prog-hero-top">
          <div>
            <div className="prog-kicker">Workspace</div>
            <div className="prog-title">Welcome{profile?.full_name ? `, ${profile.full_name.split(' ')[0]}` : ''}</div>
            <div className="prog-subtitle">Open programmes and projects to continue transformation delivery work.</div>
          </div>
          <button type="button" className="btn-ghost" onClick={() => signOut()}>Sign out</button>
        </div>
      </div>

      <div className="role-grid" style={{ marginTop: 0 }}>
        <button type="button" className="role-card" onClick={() => navigate('/home')}>
          <h3>Programmes and projects</h3>
          <span>Portfolio home — status, RAID, milestones, and initiation chain.</span>
        </button>
      </div>
    </div>
  );
}
